import { formatUnits } from 'viem'

import { formatTimeseriesData } from '@/components/charts/helpers/highcharts'

interface SupplyHistoryPoint {
  timestamp: number
  totalAssets: string | null
  totalAssetsUsd: number | null
}

const toAmount = (raw: string | null, decimals: number) =>
  raw === null ? null : Number(formatUnits(BigInt(raw), decimals))

/**
 * The chart series in USD or in the asset's units, empty without the asset's decimals. A series without a single
 * value is empty, so the chart shows its no-data state, except in USD when the history has points:
 * their USD values are missing, which `missingUsd` reports so the chart shows its error state
 * rather than an empty or $0 series.
 */
export function toTotalDepositSeries(
  points: readonly SupplyHistoryPoint[],
  unit: 'usd' | { decimals: number | null }
): { data: [number, number | null][]; missingUsd: boolean } {
  const decimals = unit === 'usd' ? null : unit.decimals
  const series =
    unit === 'usd'
      ? formatTimeseriesData(points.map(point => ({ x: point.timestamp, y: point.totalAssetsUsd })))
      : decimals === null
        ? []
        : formatTimeseriesData(
            points.map(point => ({ x: point.timestamp, y: toAmount(point.totalAssets, decimals) }))
          )
  if (series.some(([, y]) => y !== null)) return { data: series, missingUsd: false }
  return { data: [], missingUsd: unit === 'usd' && points.length > 0 }
}
